import { isCourse } from '../../course/course.util';
import { Course } from '../../course/course.model';
import { Camp } from '../../camp/camp.model';
import { Workshop } from '../../workshop/workshop.model';
import { isWorkshop } from '../../workshop/workshop.util';
import { isCamp } from '../../camp/lib/camp.util';
import { Activity } from '../activity.model';
import { ActivityRole } from './activity.interfaces';

export function getActivityTargetKey(activity: {
  course?: Course;
  camp?: Camp;
  workshop?: Workshop;
}): 'course' | 'camp' | 'workshop' {
  if (isCourse(activity.course)) return 'course';
  if (isCamp(activity.camp)) return 'camp';
  if (isWorkshop(activity.workshop)) return 'workshop';
  throw new Error(
    'Missing one of three required fields camp, course, or workshop',
  );
}

export function getActivityRootTargetKey(activity: {
  course?: Course;
  camp?: Camp;
  workshop?: Workshop;
}): 'course.camp' | 'camp' | 'workshop' {
  if (isCourse(activity.course)) return 'course.camp';
  if (isCamp(activity.camp)) return 'camp';
  if (isWorkshop(activity.workshop)) return 'workshop';
  throw new Error(
    'Missing one of three required fields camp, course, or workshop',
  );
}

export function isActivity(resource: unknown): resource is Activity {
  return (
    resource instanceof Activity ||
    (typeof resource === 'object' &&
      resource !== null &&
      (resource as any).staff !== undefined &&
      (resource as any).role !== undefined)
  );
}

export const activityRoleLabels = {
  [ActivityRole.Monitor]: $localize`Monitor`,
  [ActivityRole.HeadMonitor]: $localize`Head Monitor`,
  [ActivityRole.Teacher]: $localize`Teacher`,
  [ActivityRole.GamesMonitor]: $localize`Games Monitor`,
  [ActivityRole.RegionalManager]: $localize`Regional Manager`,
} as const satisfies { [key in ActivityRole]: string };

export const activityRoleOptions = Object.entries(activityRoleLabels).map(
  ([key, value]) => ({ title: value, value: key as ActivityRole }),
);
